import {
  appConfig as packageAppConfig,
  IConfig,
} from 'srs.sharedcomponents/lib/esm/config/app.config'

export const appConfig: IConfig = {
  ...packageAppConfig,
  disableLeftNavForProductListCatalogue: true,
  enableDefaultProductDetailsDesign: false,
  enableProductListLayoutChangeIcons: true,
  enableProductListingCard: true,
  enableCustomImageLanguageDropdownIcon: true,
  sectionsConfig: [{ id: 100, title: 'Featured Deals', tag: 'featured-deals' }],
}
